import { createFileRoute } from '@tanstack/react-router';
import { IndustryPresetList } from '@/pages/super-admin/industry-presets/IndustryPresetList';

export const Route = createFileRoute('/_authenticated/super-admin/industry-presets/')({
	component: IndustryPresetList,
});
